import { render, staticRenderFns } from "./offlineBanner.vue?vue&type=template&id=00edfe34&lang=pug"
import script from "./offlineBanner.vue?vue&type=script&lang=ts"
export * from "./offlineBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports